// extracted by mini-css-extract-plugin
export default {"popover":"PopoverSharedStyle_popover__mUJTa","active":"PopoverSharedStyle_active__bUaqA","backdrop":"PopoverSharedStyle_backdrop__xEH7O"};